"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useInteractiveLayers;

var _react = require("react");

var _reactMapGl = require("react-map-gl");

var _useMapStore3 = _interopRequireDefault(require("./useMapStore"));

var _hooks = require("@hyperobjekt/hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Takes hovered and selected features from the store and adds appropriate state
 */
function useInteractiveLayers() {
  var _useContext = (0, _react.useContext)(_reactMapGl.MapContext),
      map = _useContext.map;

  var isLoaded = map.isStyleLoaded();

  var _useMapStore = (0, _useMapStore3["default"])(function (state) {
    return [state.hoveredFeature, state.selectedFeature];
  }),
      _useMapStore2 = _slicedToArray(_useMapStore, 2),
      hoveredFeature = _useMapStore2[0],
      selectedFeature = _useMapStore2[1];

  var previousHoveredFeature = (0, _hooks.usePrevious)(hoveredFeature);
  var previousSelectedFeature = (0, _hooks.usePrevious)(selectedFeature); // set the currently hovered feature state

  (0, _react.useEffect)(function () {
    var _hoveredFeature$layer, _previousHoveredFeatu;

    if (!isLoaded) return;
    var source = (hoveredFeature === null || hoveredFeature === void 0 ? void 0 : (_hoveredFeature$layer = hoveredFeature.layer) === null || _hoveredFeature$layer === void 0 ? void 0 : _hoveredFeature$layer.source) || (previousHoveredFeature === null || previousHoveredFeature === void 0 ? void 0 : (_previousHoveredFeatu = previousHoveredFeature.layer) === null || _previousHoveredFeatu === void 0 ? void 0 : _previousHoveredFeatu.source); // clear all hovered states

    source && map.removeFeatureState({
      source: source
    }); // set hovered state

    hoveredFeature && map.setFeatureState({
      source: hoveredFeature.layer.source,
      id: hoveredFeature.id
    }, {
      hover: true
    }); // set selected state

    selectedFeature && map.setFeatureState({
      source: selectedFeature.layer.source,
      id: selectedFeature.id
    }, {
      selected: true
    });
  }, [hoveredFeature, selectedFeature, isLoaded]); // remove the previous feature selected state

  (0, _react.useEffect)(function () {
    if (!isLoaded || !previousSelectedFeature) return;
    (selectedFeature === null || selectedFeature === void 0 ? void 0 : selectedFeature.id) !== (previousSelectedFeature === null || previousSelectedFeature === void 0 ? void 0 : previousSelectedFeature.id) && map.setFeatureState({
      source: previousSelectedFeature.layer.source,
      id: previousSelectedFeature.id
    }, {
      selected: false
    });
  }, [selectedFeature, previousSelectedFeature, isLoaded]);
}